import classNames from 'classnames';
import { ThemeNames } from 'constantsValues';
import { PageContext } from 'context/PageContext';
import { useModal } from 'hooks';
import { useContext, useState } from 'react';
import { SystemIconsComponent } from '../SystemIconsComponent';
import styles from './ConsentModal.module.scss';

export interface ConsentModalProps {
	linkText: string;
	titleConsentText?: string;
	subtitleConsentText?: string;
	toggleContentText?: string;
}

export const ConsentModal: React.FC<ConsentModalProps> = ({
	linkText,
	titleConsentText,
	subtitleConsentText,
	toggleContentText,
}) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext;
	const themeName = ThemeNames[theme];
	const [open, setOpen] = useState(false);
	const { displayModal } = useModal();

	const handleClick = (event) => {
		event.preventDefault();
		setOpen(!open);
		displayModal({
			title: titleConsentText || ' ',
			subtitle: subtitleConsentText || ' ',
			content: toggleContentText,
			className: styles.ConsentModal + ' RichText',
		});
	};

	return (
		<div
			className={classNames(styles.ConsentModal, 'RichText')}
			onClick={handleClick}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') handleClick(e);
			}}
			tabIndex={0}
			role='button'
		>
			<div className={styles.ConsentModal__toggle}>
				<div className={styles.ConsentModal__toggle__label}>{linkText}</div>
				<div className={styles.ConsentModal__toggle__icon}>
					<SystemIconsComponent
						icon='Info'
						height='18'
						themeName={themeName}
					/>
				</div>
			</div>
		</div>
	);
};
